type ReportBrandingUser = {
  name?: string;
  phone?: string;
  address?: string;
  state?: string;
  country?: string;
} | null | undefined;

export const getReportBrandingPreview = (user: ReportBrandingUser) => {
  const name = String(user?.name || '').trim();
  const phone = String(user?.phone || '').trim();
  const address = [user?.address, user?.state, user?.country]
    .map((part) => String(part || '').trim())
    .filter(Boolean)
    .join(', ');

  if (!name || !phone || !address) return null;

  return { name, phone, address };
};

export const hasProfileReportAddress = (user: ReportBrandingUser) => (
  Boolean(String(user?.address || '').trim())
);
